
let accordion = [
  {
    'title':'Which WisDuo module is right for me?',
    'description':`<p>If you need<strong> LoRaWAN with WiFi and BLE</strong>, choose the RAK11160. For <strong>Amazon Sidewalk projects</strong>, choose the RAK4630. For the <strong>most power-efficient designs</strong> requiring local wireless access, consider the RAK11720 as a <strong>BLE-enabled LoRaWAN module</strong>. For <strong>compact STM32-based LoRaWAN</strong>, the RAK3172 or RAK3172-SiP are ideal.</p>`
  },
  {
    'title':'Can I program these modules with Arduino?',
    'description':`<p>Yes. All WisDuo modules with RUI3 firmware support Arduino IDE for custom firmware development, in addition to AT commands.</p>`
  },
  {
    'title':'Do these modules support LoRaWAN and LoRa P2P?',
    'description':`<p>Yes. All WisDuo modules support both LoRaWAN (Class A, B, C as specified) and LoRa point-to-point communication modes.</p>`
  },
  {
    'title':'Are antennas included?',
    'description':`<p>Modules are sold without antennas. Some variants include IPEX connectors for external antennas, and others expose RF pins for custom designs.</p>`
  },
  {
    'title':'What type of antenna connectors are used?',
    'description':`<p>Modules variants with IPEX connectors use IPEX/MHF connectors. Some modules use IPEX-1/MHF1 connectors, others use IPEX-4/MHF-4 connectors.</p>`
  },
]

  
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": accordion.map(item => ({
    "@type": "Question",
    "name": item.title,
    "acceptedAnswer": {
      "@type": "Answer",
      // Strip HTML tags for schema compliance
      "text": item.description.replace(/<[^>]*>/g, "").trim()
    }
  }))
};
const script = document.createElement("script");
script.type = "application/ld+json";
script.textContent = JSON.stringify(faqSchema);
document.head.appendChild(script);


$(document).ready(function(){

  

  let accordion_html = ''

  accordion.map(a=>{
    accordion_html+=`
      <div class="accordion__container">
        <div class="accordion">
          <h3>${a.title}</h3>
          <img src="https://cdn.shopify.com/s/files/1/0177/8784/6756/files/accordion.svg?v=1723128392" class="arrow"/>
        </div>
        <div class="panel">
          ${a.description}
        </div>
      </div>
    `
  })

  $('.accordions').html(accordion_html)

  
  $('.accordion').on('click',function(){
    $(this).next().toggle()
    if($(this).next().is(":visible"))
      $(this).find('.arrow').css('transform' , 'rotate(0deg)');
    else
      $(this).find('.arrow').css('transform' , 'rotate(180deg)');
  })


  
  const swiper_collection = new Swiper('.collection .swiper',{
      enabled:true,
      slidesPerView:2,
      spaceBetween:0,
      freeMode: true,
      slidesOffsetAfter:180,
      breakpoints: {
        769: {
          slidesPerView:5,
          enabled:false
        }
      }
      
  });
 

})